var map = {
  "./applications.json": "86291",
  "./apps.json": "96540",
  "./attachment_relations.json": "82611",
  "./boarding.json": "71308",
  "./calendar.json": "44854",
  "./common.json": "22929",
  "./customizable_table.json": "80535",
  "./dashboard.json": "53744",
  "./job_ads.json": "5142",
  "./layouts.json": "5835",
  "./mailer.json": "5592",
  "./modules.json": "95881",
  "./news.json": "56995",
  "./payments.json": "37331",
  "./permission_presets.json": "72440",
  "./posting_orders.json": "1173",
  "./search.json": "34904",
  "./skills.json": "82114",
  "./statistics.json": "46367",
  "./support.json": "76355",
  "./time_tracking.json": "44267",
  "./wizard_settings.json": "3909"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 80309;
